// src/pages/Signup.jsx

import { useState } from "react";
import API from "../services/api";
import { useNavigate, Link } from "react-router-dom";
import { useSearchParams } from "react-router-dom"; 

const Signup = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  console.log(
    "FULL URL:",
    window.location.href
  );
  
  console.log(
    "SOURCE PARAM:",
    searchParams.get("source")
  );

  const source = searchParams.get("source") || "direct";

  const [formData, setFormData] = useState({
    display_name: "",
    email: "",
    password: "",
  });

  const [showPassword, setShowPassword] =
    useState(false);

  const [loading, setLoading] = useState(false);

  // =========================
  // HANDLE INPUT CHANGE
  // =========================
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // =========================
  // SIGNUP
  // =========================
  const handleSignup = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);

      const res = await API.post("/auth/signup", {
        email: formData.email,
        password: formData.password,
        display_name: formData.display_name,
        source,
      });

      if (res.data?.access_token) {
        localStorage.setItem(
          "token",
          res.data.access_token
        );
      }

      navigate("/dashboard");
    } catch (err) {
      console.error(err);
      console.error("FULL ERROR:", err);

      console.log("STATUS:", err.response?.status);
      console.log("DATA:", err.response?.data);

  alert(JSON.stringify(err.response?.data));
      alert("Signup failed");
    } finally {
      setLoading(false);
    }
  };

  // =========================
  // TWITTER SIGNUP
  // =========================
  const handleTwitterSignup = () => {
    window.location.href =
      "https://creator-mvp-hvdx.onrender.com/auth/twitter/url";
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#f8fafc",
        fontFamily: "Inter, sans-serif",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "40px 20px",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: 1100,
          display: "grid",
          gridTemplateColumns:
            "repeat(auto-fit,minmax(320px,1fr))",
          gap: 40,
          alignItems: "center",
        }}
      >
        {/* LEFT SIDE */}
        <div>
          <div
            style={{
              display: "inline-block",
              background: "#dcfce7",
              color: "#166534",
              padding: "10px 18px",
              borderRadius: 999,
              fontWeight: "bold",
              fontSize: 14,
              marginBottom: 20,
            }}
          >
            🔥 Nigerian TikTok Creators Are Getting
            Supported
          </div>

          <h1
            style={{
              fontSize:
                "clamp(2.5rem,5vw,4.5rem)",
              lineHeight: 1.05,
              marginBottom: 24,
              fontWeight: 900,
              color: "#111827",
            }}
          >
            Start Receiving
            <span style={{ color: "#f97316" }}>
              {" "}
              Fan Support
            </span>
          </h1>

          <p
            style={{
              fontSize: 19,
              color: "#4b5563",
              lineHeight: 1.8,
              marginBottom: 35,
              maxWidth: 550,
            }}
          >
            Create your creator account,
            generate your support link, and
            start receiving payments from fans
            who love your content.
          </p>

          {/* BENEFITS */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 18,
            }}
          >
            {[
              "🔗 Create your support link in minutes",
              "💸 Receive direct fan support",
              "⚡ Fast payouts via Flutterwave",
              "📲 Built for Nigerian TikTok creators",
            ].map((item, i) => (
              <div
                key={i}
                style={{
                  background: "#fff",
                  border:
                    "1px solid #e5e7eb",
                  borderRadius: 18,
                  padding: "18px 20px",
                  fontWeight: 600,
                  color: "#111827",
                  boxShadow:
                    "0 6px 18px rgba(0,0,0,0.04)",
                }}
              >
                {item}
              </div>
            ))}
          </div>

          {/* FIRST SUPPORT */}
          <div
            style={{
              marginTop: 35,
              background: "#fff7ed",
              border: "1px solid #fed7aa",
              borderRadius: 20,
              padding: 24,
            }}
          >
            <h3
              style={{
                marginTop: 0,
                marginBottom: 12,
                color: "#111827",
              }}
            >
              🎯 Your first ₦200 changes everything
            </h3>

            <p
              style={{
                margin: 0,
                lineHeight: 1.8,
                color: "#6b7280",
              }}
            >
              Post your support link in your
              TikTok bio and let your audience
              support your content directly.
            </p>
          </div>
        </div>

        {/* RIGHT SIDE */}
        <div
          style={{
            background: "#fff",
            borderRadius: 32,
            padding: "45px 35px",
            border: "1px solid #e5e7eb",
            boxShadow:
              "0 20px 50px rgba(0,0,0,0.06)",
          }}
        >
          {/* HEADER */}
          <div
            style={{
              textAlign: "center",
              marginBottom: 35,
            }}
          >
            <h2
              style={{
                fontSize: 36,
                marginBottom: 12,
                color: "#111827",
              }}
            >
              Create Creator Account
            </h2>

            <p
              style={{
                color: "#6b7280",
                lineHeight: 1.7,
                margin: 0,
              }}
            >
              Start receiving support from your
              audience.
            </p>
          </div>

          {/* FORM */}
          <form
            onSubmit={handleSignup}
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 20,
            }}
          >
            {/* CREATOR NAME */}
            <div>
              <label
                style={{
                  display: "block",
                  marginBottom: 10,
                  fontWeight: 600,
                  color: "#111827",
                }}
              >
                Creator Name
              </label>

              <input
                type="text"
                name="display_name"
                value={formData.display_name}
                onChange={handleChange}
                placeholder="Enter creator name"
                required
                style={inputStyle}
              />
            </div>

            {/* EMAIL */}
            <div>
              <label
                style={{
                  display: "block",
                  marginBottom: 10,
                  fontWeight: 600,
                  color: "#111827",
                }}
              >
                Email Address
              </label>

              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter your email"
                required
                style={inputStyle}
              />
            </div>

            {/* PASSWORD */}
            <div>
              <label
                style={{
                  display: "block",
                  marginBottom: 10,
                  fontWeight: 600,
                  color: "#111827",
                }}
              >
                Password
              </label>

              <div
                style={{
                  position: "relative",
                }}
              >
                <input
                  type={
                    showPassword
                      ? "text"
                      : "password"
                  }
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  placeholder="Create password"
                  required
                  style={inputStyle}
                />

                <span
                  onClick={() =>
                    setShowPassword(
                      (prev) => !prev
                    )
                  }
                  style={eyeStyle}
                >
                  {showPassword
                    ? "🙈 Hide"
                    : "👁️ Show"}
                </span>
              </div>
            </div>

            {/* MAIN CTA */}
            <button
              type="submit"
              disabled={loading}
              style={{
                background: "#f97316",
                color: "#fff",
                border: "none",
                padding: "18px",
                borderRadius: 14,
                fontWeight: "bold",
                fontSize: 18,
                cursor: "pointer",
                marginTop: 10,
                boxShadow:
                  "0 10px 25px rgba(249,115,22,0.25)",
                opacity: loading ? 0.7 : 1,
              }}
            >
              {loading
                ? "Creating Account..."
                : "🚀 Start Receiving Support"}
            </button>

            {/* DIVIDER */}
            <div
              style={{
                textAlign: "center",
                color: "#9ca3af",
              }}
            >
              or
            </div>

            {/* TWITTER */}
            <button
              type="button"
              onClick={handleTwitterSignup}
              style={twitterBtn}
            >
              🐦 Continue with Twitter
            </button>
          </form>

          {/* LOGIN */}
          <div
            style={{
              marginTop: 28,
              textAlign: "center",
              color: "#6b7280",
            }}
          >
            Already have an account?{" "}
            <Link
              to="/login"
              style={{
                color: "#f97316",
                fontWeight: "bold",
                textDecoration: "none",
              }}
            >
              Login
            </Link>
          </div>

          {/* TRUST */}
          <div
            style={{
              marginTop: 30,
              paddingTop: 24,
              borderTop:
                "1px solid #f3f4f6",
              textAlign: "center",
            }}
          >
            <div
              style={{
                fontWeight: "bold",
                marginBottom: 8,
                color: "#111827",
              }}
            >
              🔒 Secured by Flutterwave
            </div>

            <p
              style={{
                margin: 0,
                color: "#6b7280",
                fontSize: 14,
                lineHeight: 1.6,
              }}
            >
              Trusted infrastructure for secure
              creator payouts.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

// =========================
// STYLES
// =========================

const inputStyle = {
  width: "100%",
  padding: "16px",
  borderRadius: 14,
  border: "1px solid #d1d5db",
  fontSize: 16,
  outline: "none",
  boxSizing: "border-box",
};

const eyeStyle = {
  position: "absolute",
  right: 16,
  top: "50%",
  transform: "translateY(-50%)",
  cursor: "pointer",
  fontSize: 14,
  color: "#6b7280",
};

const twitterBtn = {
  width: "100%",
  padding: "18px",
  background: "#111827",
  color: "#fff",
  border: "none",
  borderRadius: 14,
  fontWeight: "bold",
  fontSize: 16,
  cursor: "pointer",
};

export default Signup;